import { SET_APPT_OPTIONS, CLEAR_APPT_OPTIONS } from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';

export default function(state = null, { type, payload }) {
  switch (type) {
    case SET_APPT_OPTIONS:
      return payload;
    case RESET_APP_STATE:
    case CLEAR_APPT_OPTIONS:
      return null;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/apptOptions/reducer.js